<template>
  <div class="mypost">
    <van-nav-bar
    v-if="source==1"
    title="我的帖子"
    left-arrow
    :fixed="true"
    @click-left="onClickLeft"
    />
    <van-list
    :style="{'margin-top':source==1?'45px':'0'}"
    v-model="loading"
    :finished="finished"
    finished-text="没有更多了"
    :immediate-check="false"
    @load="onLoad"
    >
    <div slot="loading" class="list-loading">
      <img :src="this.img.loading" />
      <span>正在刷新</span>
    </div>
    <div class="list-box" v-for="item in list" :key="'list_' + item.id">
      <div class="listitle ellipsis-2">{{item.title}}</div>
      <div class="f-14 ellipsis-2"><span class="c-blue" v-if="item.tags.length>0">#{{item.tags[0].name}}#</span>{{item.content}}
      </div>
      <router-link :to="{name: 'BbsShow', params: {id: item.id}}">
        <div class="c-blue f-14 text-r">查看全部</div>
      </router-link>
      <div class="pic-box" v-if="item.image.length<3&&item.image.length>0">
        <img class="pic_thumb" v-lazy="item.image[0]">
      </div>
      <div class="pic" v-if="item.image.length==3">
        <van-row gutter="5">
          <van-col span="16">
            <img v-if="item.image && item.image[0]" v-lazy="item.image[0]" />
          </van-col>
          <van-col span="8">
            <img v-if="item.image && item.image[1]" v-lazy="item.image[1]" class="right one" />
            <img v-if="item.image && item.image[2]" v-lazy="item.image[2]" class="right" />
          </van-col>
        </van-row>
      </div>
      <van-grid :border="false" :column-num="3" v-if="item.image.length>3">
        <van-grid-item v-for="(itemd, index) in item.image" :key="'imglist_' + index">
          <van-image  height="88px" radius="5" fit="cover" :src="itemd" />
        </van-grid-item>
      </van-grid>
      <van-row type="flex" justify="space-between">
        <van-col span="14">
          <van-tag color="#F6AB00" round>{{item.channel.alias}}</van-tag>         
        </van-col>
        <van-col class="bintright" span="10">
          <span class="">
            <img class="binpic" :src="img.comment">
            <span class="sourtime">{{item.comment_num}}</span>
          </span>
          <span class="binbox">
            <img class="binpic" :src="img.parise">
            <span class="sourtime">{{item.praise_num}}</span>
          </span>
        </van-col>
      </van-row>
    </div>
  </van-list>
</div>
</template>
<script>
  import list from '../../../api/member/mybbs';
  import { mapState } from 'vuex';
  import {  List, Row, Col, Button, Tag, Grid, GridItem, Image, Icon,NavBar} from 'vant';
  
  export default {
    data(){
      return{
        list: [],
        page:1,
        cid:'',
        user_id:'',
        loading: false,
        finished: false,
        num:10,
        img: {
         parise: require('../../../assets/img/parise.png'),
         parise_have: require('../../../assets/img/parise_have.png'),
         comment: require('../../../assets/img/comment.png'),
         avatar: require('../../../assets/img/default.jpg'),
         loading: require('../../../assets/img/loading.gif')
       }
     }
   },
   computed: {
    ...mapState({
      source: state => state.param.source
    })
  },
  created () {
    this.$store.commit('param/show', false)
    if(!Lockr.get('token')) {

      if(this.source == 3||this.source == 7) {
        this.$appService.getToken(v => {
          if(v.token) {
            this.$store.dispatch('param/setToken', v.token)
          } else {
            this.$appService.needLogin()
          }
        })
      }

      this.$toast('请先登录')
      return false
    }
    if(this.source == 3||this.source == 7) {
      this.$appService.isShowReturn({state: true})
    }

    let params={
      cid:"",
      page:this.page,
    }
    this.getMypost(params)
    var apppar={
        title:this.$route.meta.title
      }
      this.$appService.changeTitle(apppar)
  },
  methods: {
    getMypost(params){
      list.getMypost(params).then(res => {
        if(res.data.state == 1) {
          let list=this.list
          let newlist=res.data.data.data
          if(list.length==0){
            this.list = res.data.data.data
          }else{
            this.num=newlist.length
            this.list = this.list.concat(newlist)
          }

        }
      })
    },
    onClickLeft(){
      this.$router.go(-1)
    },
    onLoad() {
      // 异步更新数据
      setTimeout(() => {
        let num=this.num
        if (num <10) {
          this.finished = true
          this.loading = false
        }else{
          this.page=this.page+1
          let params={
            cid:"",
            page:this.page
          }
          this.getMypost(params)
          this.loading = false
        }
      }, 500);
    },
  },
  components: {
    [Row.name]: Row,
    [Col.name]: Col,
    [Grid.name]: Grid,
    [GridItem.name]: GridItem,
    [List.name]: List,
    [Button.name]: Button,
    [Tag.name]: Tag,
    [Image.name]:Image,
    [Icon.name]:Icon,
    [NavBar.name]:NavBar
  }
}
</script>

<style lang="scss">
.mypost{
  // .van-nav-bar__left {
  //  left: 10px;
  // }
  .list-box{
    padding: 15px;
    border-bottom: 1px solid #f8f8f8;
    a {
      padding: 0;
      color: #3A3A3A;
    }
    .picone{
      width:100%;
      height:105px;
      border-radius:5px;
      object-fit: cover;
    }
    .listitle{
      font-size: 16px;
      font-weight:bold;
      line-height: 1.8;
      letter-spacing: 1.4px;
    }
    .sourtime{
      font-size:14px;
      color:rgba(154,154,154,1);
    }
    .bintright{
      text-align:right;
      .binbox{
        margin-left:20px;
      }
      .binpic{
        width:15px;
        height:14px;
        margin-right:8px;
      }
    }
    .pic-box {
      padding: 10px 0 10px 0 !important;
      height: 210px !important;
      .pic_thumb{
        border-radius: 5px;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .pic {
      img {
        width: 100%;
        height: 205px;
        object-fit: cover;
        display: block;
        border-radius: 3px;

        &.right {
          height: 100px;
        }
        &.one {
          margin-bottom: 5px;
        }
      }
      .pic-grid{
        width: 33.33%;
        float: left;
        padding: 5px;
        box-sizing:border-box;
        height: 100px;
      }
    }
    .listhand{
      width:45px;
      height:45px;
      border-radius:30px;
    }
    .membername{
      font-size: 15px;
      font-weight: bold;
    }
    .van-tag{
      padding: 0 .5em;
    }
    .quespic{
      width: 22px;
      height: 22px;
    }
    .van-grid-item__content{
      padding: 5px 5px;
    }
  }
}
</style>
